import React from "react";
import { Header, Footer, Bottomtabs } from "../components/Common";
import { useMediaQuery } from 'react-responsive';
import { useLocation } from 'react-router-dom';
import Loader from "../components/Common/Loader";

const Desktoplayout = ({ children }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 576px)' });
    const { pathname } = useLocation();

    const hideFooterRoutes = ["/cart", "/deliveryaddress", "/Payment"];
    const isInHideRoutes = hideFooterRoutes.includes(pathname) || pathname.startsWith("/products-category");

    const hideFooter = isMobile && isInHideRoutes;

    return (
        <div>
            <Header />
            <div >{children}</div>
            {/* <Loader /> */}
            {!hideFooter && <Footer />}
        </div>
    );
};

export default Desktoplayout;
